import React from 'react'
import { Button } from 'antd'

import config from 'src/config/app'

import {
  ValueContainer,
  Title,
  CardsContainer,
  CardRight,
  CardLeft,
  Image,
  Description,
} from './styles'

const valueData = [
  {
    id: 1,
    image: '/images/aboutus/icon1.png',
    alt: 'Cotización Rápida',
    title: 'Cotización Rápida',
    description:
      'Atendemos tus pedidos con  agilidad y precisión, impulsados por nuestra inteligencia artificial.',
  },
  {
    id: 2,
    image: '/images/aboutus/icon2.png',
    alt: 'Compra a crédito',
    title: 'Compra a crédito',
    description: 'Ofrecemos financiamiento previa evaluación.',
  },
  {
    id: 3,
    image: '/images/aboutus/icon3.png',
    alt: 'Todo en un solo lugar',
    title: 'Todo en un solo lugar',
    description:
      'Ofrecemos una gran variedad de materiales de construcción para todas las etapas de tu proyecto de diversas marcas y categorías.',
  },
  {
    id: 4,
    image: '/images/aboutus/icon4.png',
    alt: 'Puesto en obra',
    title: 'Puesto en obra',
    description: 'Entregamos tus pedidos en la dirección que nos solicites.',
  },
]

const wsp_endpoint = `https://api.whatsapp.com`
const cellNumber = config.web.cellNumber?.replace(/([\+\ \&])/g, '')
const message = 'Hola, me gustaría solicitar una cotización rápida.'

const ValueProposition = () => {
  const handleWhatsapp = () => {
    window.open(`${wsp_endpoint}/send?phone=${cellNumber}&text=${message}`, '_blank')
  }

  return (
    <ValueContainer>
      <Title>Nuestra propuesta de Valor</Title>
      <CardsContainer>
        {valueData.map((item, index) =>
          index % 2 === 0 ? (
            <CardRight key={item.id}>
              <Image src={item.image} alt={item.alt} />
              <Description>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </Description>
            </CardRight>
          ) : (
            <CardLeft key={item.id}>
              <Image src={item.image} alt={item.alt} />
              <Description>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </Description>
            </CardLeft>
          )
        )}
      </CardsContainer>
      <Button
        onClick={handleWhatsapp}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '16px',
          width: '350px',
          height: '70px',
          backgroundColor: '#fa8c16',
          borderRadius: '32px',
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#030852',
          marginBlock: '24px',
        }}
      >
        <img src="/icons/whatsApp.png" alt="Whatsapp" width={40} height={40}></img>
        <p
          style={{
            fontFamily: 'Poppins',
          }}
        >
          Cotiza por Whatsapp{' '}
        </p>
      </Button>
    </ValueContainer>
  )
}

export default ValueProposition
